function MainaIcon({sizeNum=2.5}) {
  const sizeStyle = { width: `${sizeNum}rem`, height: `${sizeNum}rem` };
  return (
    <svg
    style={sizeStyle}
      className={`flex-shrink-0 sm:block hs-tab-active:text-blue-600 text-gray-800`}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="white"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        className="stroke-[0.6836]"
        d="M17.24,19.05c0.59,0,1.68-0.15,2.07-0.01c0.2,0.07,0.41,0.16,0.4,0.55c-0.01,0.43-0.38,0.81-0.74,0.89
	c-0.41,0.09-1.52,0-1.52,0L17.24,19.05z"
      />
      <path
        className="stroke-[0.6836]"
        d="M9.9,16.8c-0.56,1.34-1.61,6.43-0.42,6.85c1.11,0.39,1.54-1.64,3.93-1.57c3.45,0.1,2.84,1.78,4.18,1.66
	c1.25-0.12,0.75-5.34-0.35-6.53C16.48,16.39,9.9,16.8,9.9,16.8z"
      />
      <path
        className="stroke-[0.6836]"
        d="M9.96,18.59c-1.31-0.48-2.53-1.19-3.36-2.28c-0.71-0.93-1.18-2.78-0.15-3.18c1-0.39,1.57,1.19,2.44,1.87
	c0.86,0.68,1.23,0.97,4.63,0.98c1.25,0,3.05,0.17,4.75-0.99c0.85-0.58,1.44-1.45,2.07-1.36c0.47,0.06,1.07,1.01,0.3,2.6
	c-0.68,1.38-2.32,1.85-3.5,2.35"
      />
      <g>
        <path
          className="stroke-[0.6266]"
          d="M13.67,2.71c-0.29-0.88,0.82-1.64,1.18-1.91c0.36-0.27,1.66-0.64,2.26-0.43c0.69,0.23,1.07,0.96,1.09,1.65
		c0.02,0.8-0.1,2.06-0.31,2.94s-0.63,2.69-0.99,3.26c-0.36,0.57-1.74,0.83-1.58-0.34c0.15-1.12,0.26-1.81,0.28-2.49
		s0.24-1.97,0.08-2.26c-0.1-0.18-0.37-0.12-0.78,0C14.51,3.24,13.83,3.2,13.67,2.71z"
        />
        <path
          className="stroke-[0.5697]"
          d="M11.26,9.04C9.63,6.31,9.3,4.11,9.23,3.52C9.15,2.91,9.02,0.43,10.3,0.25c1.27-0.19,1.74,1.72,1.78,3.17
		c0.11,3.87-0.11,5.08-0.11,5.08L11.26,9.04z"
        />
        <path
          className="stroke-[0.5697]"
          d="M20.17,11.48c0,2.53-2.76,4.54-6.67,4.54s-7.05-1.87-7.05-4.4s3.16-4.58,7.07-4.58S20.17,8.95,20.17,11.48z"
        />
        <polyline
          className="stroke-[0.7406]"
          points="9.55,9.51 10.57,9.51 10.57,12.03 	"
        />
        <polyline
          className="stroke-[0.7406]"
          points="15.72,9.51 16.69,9.51 16.69,12.03 	"
        />
        <ellipse
          className="stroke-[0.6266]"
          cx="13.54"
          cy="12.72"
          rx="0.29"
          ry="0.12"
        />
        <path
          className="stroke-[0.6266]"
          d="M15.16,13.62c0,0.71-0.75,1.28-1.69,1.28s-1.69-0.57-1.69-1.28"
        />
      </g>
      <path
        className="stroke-[0.2848]"
        d="M8.98,14.91l-7.17,0.71c-0.23,0.02-0.44-0.15-0.46-0.38L1,11.65c-0.02-0.23,0.15-0.44,0.38-0.46l7.17-0.71
	c0.23-0.02,0.44,0.15,0.46,0.38l0.35,3.58C9.39,14.68,9.22,14.89,8.98,14.91z"
      />
      <path
        className="stroke-[0.1139]"
        d="M8.52,14.52l-3.79,0.37c-0.15,0.01-0.28-0.1-0.3-0.25l-0.08-0.82c-0.01-0.15,0.1-0.28,0.25-0.3l3.79-0.37
	c0.15-0.01,0.28,0.1,0.3,0.25l0.08,0.82C8.78,14.37,8.67,14.5,8.52,14.52z"
      />
      <path
        className="stroke-[0.1139]"
        d="M3.82,15.02L1.97,15.2c-0.14,0.01-0.27-0.09-0.28-0.23L1.5,13.06c-0.01-0.14,0.09-0.27,0.23-0.28l1.85-0.18
	c0.14-0.01,0.27,0.09,0.28,0.23l0.19,1.91C4.06,14.88,3.96,15.01,3.82,15.02z"
      />
      <g>
        <line className="stroke-0" x1="2.19" y1="11.57" x2="8.11" y2="10.9" />
        <g>
          <line
            className="stroke-[0.1709]"
            x1="2.19"
            y1="11.57"
            x2="2.36"
            y2="11.55"
          />
          <line
            className="stroke-[0.1709]"
            x1="2.68"
            y1="11.51"
            x2="7.77"
            y2="10.94"
          />
          <line
            className="stroke-[0.1709]"
            x1="7.94"
            y1="10.92"
            x2="8.11"
            y2="10.9"
          />
        </g>
      </g>
      <g>
        <line className="stroke-0" x1="2.22" y1="11.99" x2="8.14" y2="11.32" />
        <g>
          <line
            className="stroke-[0.1709]"
            x1="2.22"
            y1="11.99"
            x2="2.39"
            y2="11.97"
          />
          <line
            className="stroke-[0.1709]"
            x1="2.72"
            y1="11.93"
            x2="7.81"
            y2="11.36"
          />
          <line
            className="stroke-[0.1709]"
            x1="7.97"
            y1="11.34"
            x2="8.14"
            y2="11.32"
          />
        </g>
      </g>
      <g>
        <line className="stroke-0" x1="2.26" y1="12.42" x2="8.18" y2="11.75" />
        <g>
          <line
            className="stroke-[0.1709]"
            x1="2.26"
            y1="12.42"
            x2="2.43"
            y2="12.4"
          />
          <line
            className="stroke-[0.1709]"
            x1="2.76"
            y1="12.36"
            x2="7.85"
            y2="11.79"
          />
          <line
            className="stroke-[0.1709]"
            x1="8.01"
            y1="11.77"
            x2="8.18"
            y2="11.75"
          />
        </g>
      </g>
      <g>
        <path
          className="stroke-[0.0749]"
          d="M2.71,13.26c-0.04-0.1,0.08-0.2,0.12-0.24c0.04-0.04,0.19-0.09,0.26-0.08c0.08,0.02,0.14,0.1,0.15,0.18
		c0.01,0.09,0.01,0.25,0,0.35s-0.04,0.33-0.08,0.4c-0.04,0.07-0.2,0.12-0.19-0.02c0-0.14,0.01-0.22,0-0.3s0.01-0.24-0.02-0.27
		c-0.01-0.02-0.05-0.01-0.09,0.01C2.82,13.31,2.74,13.31,2.71,13.26z"
        />
        <path
          className="stroke-[0.0681]"
          d="M2.5,14.04c-0.23-0.31-0.29-0.56-0.31-0.63c-0.02-0.07-0.06-0.36,0.09-0.4c0.15-0.04,0.23,0.18,0.25,0.36
		c0.06,0.46,0.05,0.61,0.05,0.61L2.5,14.04z"
        />
        <path
          className="stroke-[0.0681]"
          d="M3.59,14.22c0.03,0.3-0.28,0.57-0.74,0.62S1.99,14.7,1.96,14.4c-0.03-0.3,0.32-0.58,0.79-0.63
		C3.21,13.73,3.56,13.92,3.59,14.22z"
        />
        <polyline
          className="stroke-[0.0885]"
          points="2.3,14.11 2.42,14.1 2.45,14.4 	"
        />
        <polyline
          className="stroke-[0.0885]"
          points="3.04,14.04 3.15,14.03 3.18,14.33 	"
        />
        <ellipse
          transform="matrix(0.9952 -0.0979 0.0979 0.9952 -1.4012 0.345)"
          className="stroke-[0.0749]"
          cx="2.82"
          cy="14.45"
          rx="0.03"
          ry="0.01"
        />
        <path
          className="stroke-[0.0749]"
          d="M3.02,14.54c0.01,0.08-0.07,0.16-0.19,0.17s-0.21-0.05-0.22-0.13"
        />
      </g>
    </svg>
  );
}

export default MainaIcon;
